// extracted by mini-css-extract-plugin
module.exports = {"navigation":"Tabs_navigation__3If4W","item":"Tabs_item__Zo1cE","activeItem":"Tabs_activeItem__1naS8","link":"Tabs_link__UPRNK","linkRuns":"Tabs_linkRuns__zjtiq"};